import {Box, FormControl, InputAdornment, OutlinedInput, Typography} from "@mui/material";
import {ChangeEvent, useState} from "react";

const _debounce = require('lodash/debounce');

interface Props {
    value: number
    setValue: (inputValue: number) => void
    unit: string | undefined
}

export function MeasureAmountInput(props: Props) {
    const {
        value,
        setValue,
        unit
    } = props
    /**
     * props.setValue issues a http request to backend
     * To avoid http request spam during slider changes, debounce invocations
     */
    const [localValue, setLocalValue] = useState(value)
    const [stateDebounceSetValue] = useState(() => _debounce(setValue, 500))

    function handleInputChange(inputValue: number) {
        if (inputValue !== undefined) {
            setLocalValue(inputValue)
            stateDebounceSetValue(inputValue)
        }
    }

    return (
        <Box style={{display: "flex", flex: "auto 1", columnGap: "20px", alignItems: "center"}}>
            <Typography>
                Produksjon
            </Typography>
            <FormControl variant="outlined"  sx={{ maxWidth: "150px" }}>
                <OutlinedInput endAdornment={<InputAdornment disablePointerEvents position="end">{unit}</InputAdornment>}
                               onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange(+e.target.value)}
                    // https://stackoverflow.com/questions/30626094/remove-leading-zeros-from-input-type-number
                               value={Number(localValue).toString()}
                               type="number"
                />
            </FormControl>
        </Box>
    )
}